import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import ButtonItem from '../components/ButtonItem';
import GenericAutoCompleteInput from '../components/GenericAutoCompleteInput';
import { useNavigate } from 'react-router-dom';
import { GENRES } from '../data/genres';

function SongWritePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const audioFileInputRef = useRef(null);
  const { key } = useParams();
  const { albumIdToSong } = location.state || {};
  const [genreId, setGenreId] = useState('1');
  const [disc, setDisc] = useState('1');
  const [track, setTrack] = useState('');
  const [nameKr, setNameKr] = useState('');
  const [artistKr, setArtistKr] = useState('');
  const [writerKr, setWriterKr] = useState('');
  const [composerKr, setComposerKr] = useState('');
  const [arrangerKr, setArrangerKr] = useState('');
  const [code, setCode] = useState('');
  const [isrc, setIsrc] = useState('');
  const [uci, setUci] = useState('');
  const [titleYn, setTitleYn] = useState('Y');
  const [adultYn, setAdultYn] = useState('N');
  const [album, setAlbum] = useState({ id: null, name: '' });
  const [albumArtistKr, setAlbumArtistKr] = useState('');
  const [audioFile, setAudioFile] = useState(null); // 새로 업로드할 파일
  const [audioPreview, setAudioPreview] = useState(''); // 미리듣기용 URL
  const [uploadProgress, setUploadProgress] = useState(0); // 0 ~ 100
  const [isUploading, setIsUploading] = useState(false);


  useEffect(() => {
    if (!albumIdToSong) return;
    const fetchData = async () => {
      try {
        const response = await axios.get(`/album/${albumIdToSong}`);
        setAlbum({ id: response.data.id, name: response.data.nameKr });
        setAlbumArtistKr(response.data.artist.nameKr);
        setTrack((prev) => String(Number(prev) + 1));
        setNameKr('');
        setArtistKr('');
        setWriterKr('');
        setComposerKr('');
        setArrangerKr('');
        setCode('');
        setIsrc('');
        setUci('');
        setAudioFile(null);
        if (audioFileInputRef.current) {
          audioFileInputRef.current.value = '';
        }
        setAudioPreview('');
        window.scrollTo(0, 0);
      } catch (error) {
        console.error('서버 접속 에러:', error);
      }
    };
    fetchData();
  }, [albumIdToSong, key]);

  // 각 인풋 값 저장
  const discChange = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setDisc(inputValue.replace(/[^0-9]/g, ''));
  };
  const trackChange = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setTrack(inputValue.replace(/[^0-9]/g, ''));
  };
  const nameKrChange = (event) => setNameKr(event.target.value);
  const artistKrChange = (event) => setArtistKr(event.target.value);
  const writerKrChange = (event) => setWriterKr(event.target.value);
  const composerKrChange = (event) => setComposerKr(event.target.value);
  const arrangerKrChange = (event) => setArrangerKr(event.target.value);
  const codeChange = (event) => setCode(event.target.value);
  const isrcChange = (event) => setIsrc(event.target.value);
  const uciChange = (event) => setUci(event.target.value);
  const titleYnChange = (event) => setTitleYn(event.target.value);
  const adultYnChange = (event) => setAdultYn(event.target.value);

  // 오디오 파일 선택 핸들러
  const handleAudioFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAudioFile(file);
      setAudioPreview(URL.createObjectURL(file));
    }
  };

  // 등록 버튼
  const add = async () => {
    // 입력값 검사
    if (
      !album ||
      !genreId ||
      !disc ||
      !track ||
      !audioFile ||
      !nameKr ||
      !artistKr ||
      !writerKr ||
      !composerKr ||
      !arrangerKr ||
      !code ||
      !isrc ||
      !uci ||
      !titleYn ||
      !adultYn
    ) {
      alert('필수 항목을 빠짐없이 입력해 주세요.');
      return;
    }

    const formData = new FormData();
    formData.append('albumId', album.id);
    formData.append('genreId', genreId);
    formData.append('disc', disc);
    formData.append('track', track);
    formData.append('nameKr', nameKr);
    formData.append('artistKr', artistKr);
    formData.append('writerKr', writerKr);
    formData.append('composerKr', composerKr);
    formData.append('arrangerKr', arrangerKr);
    formData.append('code', code);
    formData.append('isrc', isrc);
    formData.append('uci', uci);
    formData.append('titleYn', titleYn);
    formData.append('adultYn', adultYn);
    formData.append('audio', audioFile); // 백엔드에서 multer.single('audio')로 받음

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const response = await axios.post(`/song`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percent);
          }
        },
      });
      setIsUploading(false);
      setUploadProgress(100);

      // 등록 완료 후 추가 등록 여부 확인
      const isContinue = window.confirm(
        '곡 등록이 완료되었습니다.\n계속 등록하시겠습니까?'
      );
      if (isContinue) {
        // 계속등록: 페이지 리마운트
        navigate(`/songWrite/${Date.now()}`, {
          state: { albumIdToSong: album.id },
        });
      } else {
        window.location.href = `/songs/${response.data.id}`;
      }
    } catch (error) {
      setIsUploading(false);
      setUploadProgress(0);
      alert('등록 중 오류가 발생했습니다.');
    }
  };

  // 앨범명 리스트 불러오기 함수
  const fetchAlbumNames = async () => {
    const response = await axios.get(`/album?limit=9999`);
    return response.data.items.map((album) => ({
      id: Number(album.id),
      name: album.nameKr,
    }));
  };

  // 앨범 오토컴플리트의 onChange 핸들러
  const handleAlbumChange = async (selectedAlbum) => {
    setAlbum(selectedAlbum);

    // 앨범 id로 상세 정보 조회 (아티스트명 포함)
    if (selectedAlbum?.id) {
      const res = await axios.get(`/album/${selectedAlbum.id}`);
      setAlbumArtistKr(res.data.artist?.nameKr);
    } else {
      setAlbumArtistKr('');
    }
  };

  return (
    <>
        <div className="flex mb-8 justify-center items-center">
          <h1 className="text-xl sm:text-2xl font-bold">곡 등록</h1>
        </div>

        <div className="space-y-6 max-w-2xl mx-auto">
          {/* 앨범명 */}
          <div>
            <GenericAutoCompleteInput
              label="앨범명"
              value={album}
              onChange={handleAlbumChange}
              fetchOptions={fetchAlbumNames}
              placeholder="앨범을 선택하세요"
              // id={id}
            />
          </div>

          {/* 앨범 아티스트 */}
          <div>
            <label className="block font-semibold mb-1">앨범 아티스트</label>
            <input
              type="text"
              value={albumArtistKr}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 음원파일 업로드 */}
          <div>
            <label className="block font-semibold mb-1">음원파일 업로드</label>
            <input
              type="file"
              ref={audioFileInputRef}
              accept="audio/mp3,audio/mpeg"
              onChange={handleAudioFileChange}
              className="block w-full text-sm text-slate-400 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-md file:font-semibold file:bg-sky-500/10 file:text-sky-500 hover:file:bg-sky-500/20 hover:cursor-pointer"
            />
            {/* 업로드 진행 모달 */}
            {isUploading && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50">
                <div className="bg-[#1a2b42] rounded-lg p-6 w-80 shadow-lg border border-white/10">
                  <div className="text-center font-semibold mb-4 text-white">
                    업로드 진행 중...
                  </div>
                  <div className="w-full bg-white/[0.1] rounded-full h-6 overflow-hidden">
                    <div
                      className="bg-sky-500 h-6 transition-all duration-300"
                      style={{ width: `${uploadProgress}%` }}></div>
                  </div>
                  <div className="text-center mt-2 text-lg font-mono text-slate-200">
                    {uploadProgress}%
                  </div>
                </div>
              </div>
            )}
            {/* 새 파일 미리듣기 */}
            {audioPreview && (
              <div className="mt-2">
                <label className="block text-sm">업로드 한 음원 듣기</label>
                <audio controls src={audioPreview} style={{ width: '100%' }} />
              </div>
            )}
            {/* 기존 파일 미리듣기 (새 파일 없을 때만)
              {!audioPreview && fileUrl && (
                <div className="mt-2">
                  <label className="block text-sm">기존 음원 듣기</label>
                  <audio controls src={fileUrl} style={{ width: '100%' }} />
                </div>
              )} */}
          </div>

          {/* 장르 */}
          <div>
            <label className="block font-semibold mb-1">장르</label>
            <select
              value={genreId}
              onChange={(e) => setGenreId(e.target.value)}
              className="w-full px-2 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent">
              {GENRES.map((g) => (
                <option key={g.id} value={g.id}>{g.label}</option>
              ))}
            </select>
          </div>

          {/* 디스크 */}
          <div>
            <label className="block font-semibold mb-1">디스크</label>
            <input
              type="text"
              value={disc}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={discChange}
            />
          </div>

          {/* 트랙 */}
          <div>
            <label className="block font-semibold mb-1">트랙</label>
            <input
              type="text"
              value={track}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={trackChange}
            />
          </div>

          {/* 곡명 */}
          <div>
            <label className="block font-semibold mb-1">곡명</label>
            <input
              type="text"
              value={nameKr}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={nameKrChange}
            />
          </div>

          {/* 아티스트 */}
          <div>
            <label className="block font-semibold mb-1">곡 아티스트</label>
            <input
              type="text"
              value={artistKr}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={artistKrChange}
            />
          </div>

          {/* 작사 */}
          <div>
            <label className="block font-semibold mb-1">작사</label>
            <input
              type="text"
              value={writerKr}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={writerKrChange}
            />
          </div>

          {/* 작곡 */}
          <div>
            <label className="block font-semibold mb-1">작곡</label>
            <input
              type="text"
              value={composerKr}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={composerKrChange}
            />
          </div>

          {/* 편곡 */}
          <div>
            <label className="block font-semibold mb-1">편곡</label>
            <input
              type="text"
              value={arrangerKr}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={arrangerKrChange}
            />
          </div>

          {/* 코드 */}
          <div>
            <label className="block font-semibold mb-1">곡 코드</label>
            <input
              type="text"
              value={code}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={codeChange}
            />
          </div>

          {/* isrc */}
          <div>
            <label className="block font-semibold mb-1">isrc</label>
            <input
              type="text"
              value={isrc}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={isrcChange}
            />
          </div>

          {/* uci */}
          <div>
            <label className="block font-semibold mb-1">uci</label>
            <input
              type="text"
              value={uci}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              onChange={uciChange}
            />
          </div>

          {/* 타이틀 */}
          <div>
            <label className="block font-semibold mb-1">타이틀여부</label>
            <div className="flex gap-6">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="titleYn"
                  value="Y"
                  checked={titleYn === 'Y'}
                  onChange={titleYnChange}
                />
                <span>타이틀</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="titleYn"
                  value="N"
                  checked={titleYn === 'N'}
                  onChange={titleYnChange}
                />
                <span>수록곡</span>
              </label>
            </div>
          </div>

          {/* 19금 */}
          <div>
            <label className="block font-semibold mb-1">19금여부</label>
            <div className="flex gap-6">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="adultYn"
                  value="Y"
                  checked={adultYn === 'Y'}
                  onChange={adultYnChange}
                />
                <span>19금</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="adultYn"
                  value="N"
                  checked={adultYn === 'N'}
                  onChange={adultYnChange}
                />
                <span>전체</span>
              </label>
            </div>
          </div>
        </div>

        <div className="w-full flex justify-end items-center mt-5">
          <ButtonItem
            className="mr-2"
            text="목록"
            color="gray"
            onClick={() => navigate('/Songs')}
          />
          <ButtonItem text="등록완료" color="blue" onClick={add} />
        </div>
    </>
  );
}

export default SongWritePage;
